import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, EmptyState, Skeleton, Tabs, fmtCoins } from "../ui";
import api from "../../services/api";
import { errorInfo } from "../../services/errors";
import { usageLabel } from "./usage";

const TABS = [
  { value: "all", label: "ทั้งหมด" },
  { value: "out", label: "ใช้ไป" },
  { value: "in", label: "ได้รับ" },
  { value: "purchase", label: "เติมเงิน" },
];

/** ประวัติคอยน์ (coin_tx) แบ่งหน้า — compact = ไม่มีแท็บ/โหลดเพิ่ม ใช้ในหน้าคลับ */
export default function CoinHistory({ refreshKey, compact, limit = 15 }) {
  const [tab, setTab] = useState("all");
  const [state, setState] = useState({ items: null, nextCursor: null, error: "" });
  const [more, setMore] = useState(false);

  useEffect(() => {
    let alive = true;
    setState((s) => ({ ...s, items: s.items && s.items.length ? s.items : null, error: "" }));
    api.coins.historyPage({ limit: compact ? 5 : limit, ...(tab === "purchase" ? { usageType: "purchase" } : {}) })
      .then((r) => alive && setState({ items: r.items, nextCursor: r.nextCursor, error: "" }))
      .catch((e) => alive && setState({ items: [], nextCursor: null, error: errorInfo(e).message }));
    return () => { alive = false; };
  }, [tab, refreshKey, compact, limit]);

  const loadMore = async () => {
    setMore(true);
    try {
      const r = await api.coins.historyPage({ limit, cursor: state.nextCursor, ...(tab === "purchase" ? { usageType: "purchase" } : {}) });
      setState((s) => ({ items: [...s.items, ...r.items], nextCursor: r.nextCursor, error: "" }));
    } catch (e) {
      setState((s) => ({ ...s, error: errorInfo(e).message }));
    } finally {
      setMore(false);
    }
  };

  // "ใช้ไป/ได้รับ" กรองฝั่งหน้าเว็บ (API กรองได้เฉพาะ usageType)
  const rows = (state.items || []).filter((t) => tab === "all" || tab === "purchase" || (tab === "in" ? t.coinUsed > 0 : t.coinUsed < 0));
  return (
    <div>
      {compact ? null : <Tabs tabs={TABS} value={tab} onChange={setTab} />}
      <div className="hist mt-16" aria-busy={state.items === null}>
        {state.items === null ? [0, 1, 2].map((i) => <Skeleton key={i} height={58} style={{ marginBottom: 8 }} />)
          : state.error ? <div className="error-text" role="alert">{state.error}</div>
          : !rows.length ? <EmptyState icon="🧾" title="ยังไม่มีรายการ">{state.nextCursor ? "ยังไม่พบในหน้านี้ กดโหลดเพิ่มเพื่อค้นต่อ" : "รายการเติม/ใช้คอยน์จะแสดงที่นี่"}</EmptyState>
          : rows.map((t) => (
            <div key={t.id} className="hist__row">
              <div className="grow">
                <div className="strong">{usageLabel(t.usageType)}</div>
                <div className="faint" style={{ fontSize: 12 }}>{new Date(t.createdAt).toLocaleString("th-TH", { dateStyle: "medium", timeStyle: "short" })}{t.note ? ` · ${t.note}` : ""}</div>
              </div>
              <div className="hist__amt" style={{ color: t.coinUsed > 0 ? "var(--success)" : "var(--text)" }}>
                {t.coinUsed > 0 ? "+" : ""}{fmtCoins(t.coinUsed)} คอยน์
                {t.balanceAfter !== undefined && t.balanceAfter !== null ? <div className="faint" style={{ fontSize: 11, fontWeight: 400 }}>คงเหลือ {fmtCoins(t.balanceAfter)}</div> : null}
              </div>
            </div>
          ))}
      </div>
      {compact ? <div className="center mt-8"><Link to="/coins" className="btn btn--sm">ดูทั้งหมดที่หน้าเติมคอยน์</Link></div>
        : state.nextCursor ? <Button block className="mt-8" onClick={loadMore} disabled={more}>{more ? "กำลังโหลด..." : "โหลดเพิ่ม"}</Button> : null}
    </div>
  );
}
